import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import './Layout.css'

const Layout = () => {
    const location = useLocation();
    const [pageTitle, setPageTitle] = useState("Dashboard");

    useEffect(() => {
        const pathToTitle = {
            "/admin/dashboard": "Dashboard",
            "/admin/customers-list": "Customer List",
            "/admin/category-list": "Category List",
            "/admin/product-list": "Product List",
            "/admin/coin-allot": "Coin Allot",
        };                                                                    

        if (pathToTitle[location.pathname]) {
            setPageTitle(pathToTitle[location.pathname]);
        }
    }, [location]);

    return (
        <div className="layout-wrapper">
            <Header title={pageTitle} />

            <div className="layout-body">
                <Sidebar setPageTitle={setPageTitle} />

                <div className="layout-content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default Layout;
